import {BaseClientInformation} from "../../";

export interface DormerClientInformation extends BaseClientInformation {
  logoUrl?: string;
}
